import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import HoverRightArrow from "web/assets/images/dropdown-menu-hover-arrow.png";

import './dropDownMenu.scss';

function DropDownMenuMyBids(props) {
  const [click, setClick] = useState(false);
  const dispatch = useDispatch();
  const handleClick = () => setClick(!click);
  const pageLanguageContents = props.content
  const userType = localStorage.getItem('accountType')
  const storedData = useSelector(
    (state) => state.storedData.payload
  );
  let disableFlg = storedData?.guestUser

  let MenuItems;
  if(disableFlg){
    MenuItems = [
      {
        title: pageLanguageContents?.Header[21]?.H_MyBidsOnNeeds,
        //path: '/MyOfferPostBids?postType=PostLoad&type=bidsPalletNeeds&activePage=PostLoad&expanded=panel2',
        path: '/view-my-bids-on-pallet-needs',
        cName: 'dropdown-link'
      },
      {
        title: pageLanguageContents?.Header[22]?.H_MyBidsOnInventory,
        //path: '/MyOfferInventoryBids?postType=PostInventory&type=bidsPalletOffers&activePage=PostInventory&expanded=panel1',
        path: '/view-my-offers-on-pallet-inventory',
        cName: 'dropdown-link'
      }
    ];
  }else{
    if (userType === "Both") {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[21]?.H_MyBidsOnNeeds,
          //path: '/MyOfferPostBids?postType=PostLoad&type=bidsPalletNeeds&activePage=PostLoad&expanded=panel2',
          path: '/view-my-bids-on-pallet-needs',
          cName: 'dropdown-link'
        },
        {
          title: pageLanguageContents?.Header[22]?.H_MyBidsOnInventory,
          //path: '/MyOfferInventoryBids?postType=PostInventory&type=bidsPalletOffers&activePage=PostInventory&expanded=panel1',
          path: '/view-my-offers-on-pallet-inventory',
          cName: 'dropdown-link'
        }
      ];
    }
    else if (userType === "Buyer") {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[22]?.H_MyBidsOnInventory,
          //path: '/MyOfferInventoryBids?postType=PostInventory&type=bidsPalletOffers&activePage=PostInventory&expanded=panel1',
          path: '/view-my-offers-on-pallet-inventory',
          cName: 'dropdown-link'
        }
      ];
    }
    else if (userType === "Seller") {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[21]?.H_MyBidsOnNeeds,
          //path: '/MyOfferPostBids?postType=PostLoad&type=bidsPalletNeeds&activePage=PostLoad&expanded=panel2',
          path: '/view-my-bids-on-pallet-needs',
          cName: 'dropdown-link'
        }
      ];
    } else {
      MenuItems = [
        {
          title: pageLanguageContents?.Header[21]?.H_MyBidsOnNeeds,
          //path: '/MyOfferPostBids?postType=PostLoad&type=bidsPalletNeeds&activePage=PostLoad&expanded=panel2',
          path: '/view-my-bids-on-pallet-needs',
          cName: 'dropdown-link'
        },
        {
          title: pageLanguageContents?.Header[22]?.H_MyBidsOnInventory,
          //path: '/MyOfferInventoryBids?postType=PostInventory&type=bidsPalletOffers&activePage=PostInventory&expanded=panel1',
          path: '/view-my-offers-on-pallet-inventory',
          cName: 'dropdown-link'
        }
      ];
    }
  }
 

  const onLinkClick = (type) => {
    //path: '/view-my-bids-on-pallet-needs?postType=PostLoad&type=bidsPalletNeeds&activePage=PostLoad&expanded=panel2',
    if (type === 'MyOfferPostBids') {
      let obj = {
        postType: "PostLoad",
        type: "bidsPalletNeeds",
        activePage: 'PostLoad',
        expanded: 'panel2'
      }
      dispatch({ type: 'BID_NEEDS', payload: obj })
    }
    //path: '/view-my-offers-on-pallet-inventory?postType=PostInventory&type=bidsPalletOffers&activePage=PostInventory&expanded=panel1',
    if (type === 'MyOfferInventoryBids') {
      let obj = {
        postType: "PostInventory",
        type: "bidsPalletOffers",
        activePage: 'PostInventory',
        // activeSearch:'Dashboard',
        expanded: 'panel1'
      }
      dispatch({ type: 'BIDS_INVENTORY', payload: obj })
    }
  };
  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu1 clicked' : 'dropdown-menu1'}
      >
        {MenuItems.map((item, index) => {
          return (
            <>{index ===0 && disableFlg?
              <li key={index}>
                  <div className='opacityDisable'>
                    <img
                      className="arrow-image"
                      src={HoverRightArrow}
                      alt="right-arrow"
                    />
                    {item.title}
                  </div>
              </li>:
                <li key={index}>
                  <Link
                    className={item.cName}
                    exact
                    to={item.path}
                    onClick={() => onLinkClick(item.type)}
                  >
                    <img
                      className="arrow-image"
                      src={HoverRightArrow}
                      alt="right-arrow"
                    />
                    {item.title}
                  </Link>
              </li>}
              </>
            
          );
        })}
      </ul>
    </>
  );
}

export default DropDownMenuMyBids;